import { useTranslation } from 'react-i18next';

export const useJournalEventsSearch = () => {
    const { t } = useTranslation();
    return { t };
};
